import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";

function VariableActionSortRenderer({variableActionNode, submitChange}) {
  const { t } = useTranslation();
  const [sortOrder, setSortOrder] = useState("ASC");
  const [ignoreCase, setIgnoreCase] = useState(false);
  const sortOrderOptionsDropdown = [
    <MenuItem key={1} value={"ASC"}>
      {t("ASC")}
    </MenuItem>,
    <MenuItem key={2} value={"DESC"}>
      {t("DESC")}
    </MenuItem>,
  ];
  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
    submitChange(null,null,{SORT_ORDER:e.target.value})
  };
  useEffect(() => {
    if(variableActionNode.ACTION === 'SORT' || variableActionNode.ACTION === 'SORT_UNIQUE'){
      if(!variableActionNode. hasOwnProperty('SORT_ORDER')){
        submitChange(null,null,{SORT_ORDER:'ASC'}) 
      }
     setSortOrder(variableActionNode.SORT_ORDER || 'ASC')
     setIgnoreCase(variableActionNode.IGNORE_CASE === 'TRUE' || false)
    }
    
  },[variableActionNode])
  return (
    <>
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="SortOrderLabel">{t("LBL_SORT_ORDER")}</InputLabel>
        <Select
          className={"width-100"}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name={"SO"}
          value={sortOrder}
          labelId="sortOrderLabel"
          label={t("LBL_SORT_ORDER")}
          id="SODropdown"
          onChange={handleSortOrderChange}>
          {sortOrderOptionsDropdown}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className="width-100" size="small">
        <TPCheckbox
          label={t("BTN_IGNORE_CASE")}
          checked={ignoreCase}
          handleCheck={(checked) => {
            setIgnoreCase(checked);
            submitChange(null,null,{IGNORE_CASE:checked ? "TRUE":"FALSE"})
          }}
        />
      </FormControl>
    </>
  );
}

export default VariableActionSortRenderer;
